import GlobalStore from 'shared/globalStore/assets/scripts/globalStore'
import Toast from 'shared/toast/toast'

type BmkAddedEvent = CustomEvent<{ contentId: string; contentType: string; type: string }>
type BmkRemovedEvent = CustomEvent<{ contentId: string; type: string }>
type BmkReadyEvent = CustomEvent<{ bookmarkedIds: string[] }>

export default class Bookmark {
	private bookmark: HTMLElement | null
	private labelNotBookmarked: HTMLElement | null | undefined
	private labelBookmarked: HTMLElement | null | undefined
	private isBookmarked: boolean
	private store: GlobalStore
	private contentType: string | null

	constructor() {
		this.bookmark = document.querySelector('.bookmark')
		this.labelNotBookmarked = this.bookmark?.querySelector('.bookmark-label.notBookmarked')
		this.labelBookmarked = this.bookmark?.querySelector('.bookmark-label.bookmarked')
		this.isBookmarked = false
		this.store = new GlobalStore()
		this.onAdded = this.onAdded.bind(this)
		this.onRemoved = this.onRemoved.bind(this)
		this.onReady = this.onReady.bind(this)
		this.contentType =
			this.bookmark?.getAttribute('data-bmk-content-type')?.toLowerCase() ?? null
	}

	init() {
		if (!this.bookmark) return
		this.addEvent()
	}

	addEvent() {
		window.addEventListener('bmk:added', this.onAdded as EventListener)
		window.addEventListener('bmk:removed', this.onRemoved as EventListener)
		window.addEventListener('bmk:ready', this.onReady as EventListener)
	}

	/**
	 * Sync aria-checked once Bookmarker has fetched the user's bookmark list
	 */
	onReady(event: BmkReadyEvent) {
		const contentId = this.bookmark?.getAttribute('data-bmk-content-id') ?? ''
		this.isBookmarked = event.detail?.bookmarkedIds?.includes(contentId) ?? false
		this.updateAriaAttributes()
	}

	/**
	 * Fired by Bookmarker when a readitlater bookmark is added
	 */
	onAdded(event: BmkAddedEvent) {
		if (event.detail?.type === 'readitlater') {
			this.isBookmarked = true
			this.updateAriaAttributes()
			this.showToast()
		}
	}

	/**
	 * Fired by Bookmarker when a readitlater bookmark is removed
	 */
	onRemoved(event: BmkRemovedEvent) {
		if (event.detail?.type === 'readitlater') {
			this.isBookmarked = false
			this.updateAriaAttributes()
			this.showToast()
		}
	}

	updateAriaAttributes() {
		this.bookmark?.setAttribute('aria-checked', String(this.isBookmarked))
		this.labelBookmarked?.setAttribute('aria-hidden', String(!this.isBookmarked))
		this.labelNotBookmarked?.setAttribute('aria-hidden', String(this.isBookmarked))
	}

	showToast() {
		const toast = new Toast({ content: this.toastLabel })
		toast.init()
	}

	get toastLabel(): string {
		return this.isBookmarked
			? `${this.contentType === 'recipe' ? 'Recette' : 'Article'} à retrouver dans votre compte ${this.store.brand?.labels.brand_name ?? ''}`
			: `${this.contentType === 'recipe' ? 'Recette retirée' : 'Article retiré'} de vos favoris`
	}
}
